module.exports = __webpack_public_path__ + "img/superbus.b8bf33a9.webp";